export const isMemberPhotoResponse = (value) => {
    if (!value || typeof value !== 'object' || !('photo' in value))
        return false;
    const p = value.photo;
    return (p === null ||
        Boolean(p &&
            typeof p.id === 'string' &&
            typeof p.memberId === 'string' &&
            ['image/jpeg', 'image/png', 'image/webp'].includes(p.mimeType) &&
            Number.isInteger(p.sizeBytes) &&
            Number.isInteger(p.width) &&
            Number.isInteger(p.height) &&
            /^[0-9a-f]{64}$/.test(p.sha256) &&
            ['pending', 'approved', 'rejected', 'replaced'].includes(p.status) &&
            typeof p.thumbnailUrl === 'string' &&
            typeof p.originalUrl === 'string'));
};
